// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldLabel_root___v_Nr","variant2":"FieldLabel_variant2__flkRQ"};